import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource } from 'kea-resource';

const controller = rpcController("ConfigSistema");

export const ConfigSistema = cacheResource({
    /**
       * Actualiza la configuración del sistema
       * @param config 
       */
    Update: async (config: models.ConfigSistemaDTO): Promise<void> => await controller("Update", {}, config),

    /**
     * Devuelve true si el sistema fue configurado inicialmente
     */
    EstaConfigurado: async (): Promise<boolean> => await controller("EstaConfigurado", {}),

    /**
 * Devuelve true si el sistema es de pruebas
 */
    EsDePruebas: async (): Promise<boolean> => await controller("EsDePruebas", {}),

    HabilitarValidacionesCartaPorte: async (): Promise<boolean> => await controller("HabilitarValidacionesCartaPorte", {}),


    /**Devuelve el tiempo en segundos del limite de tiempo se sesión sin actividad */
    LimiteTiempoSesion: async (): Promise<number> => await controller("LimiteTiempoSesion", {}),

    /**
     * Obtiene la configuración del sistema si es que hay una
     */
    Get: async (): Promise<models.ConfigSistemaDTO> => await controller("Get", {}),

    /**Obtiene el apk del config */
    GetApk: async (): Promise<string> => await controller("GetApk", {}),
    GetAviso: async (): Promise<string> => await controller("GetAviso", {}),
    GetAvisoMarkdown: async (): Promise<string> => await controller("GetAvisoMarkdown", {}),
    GetAnuncioInicio: async (): Promise<string | null> => await controller("GetAnuncioInicio", {}),

    /**Realiza la prueba de conexión con el sistema de contabilidad y devuelve una cadena con el error si hubo un error, si sale todo bien devuelve null */
    ProbarConexionContabilidad: async (): Promise<string | null> => await controller('ProbarConexionContabilidad', {}),

}, {
        EstaConfigurado: true,
        LimiteTiempoSesion: true,
        Get: true
    }, {
        Update: true
    });




// WEBPACK FOOTER //
// ./app/resources/items/configsistema.tsx